import React, { useEffect, useState } from "react";
import { Formik, Form, Field, input, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Row, Col, Select } from "antd";
import { API_CREATE_STORE } from "api/store-managemnt";
import AddressAutocomplete from "components/AddressAutocomplete/AddressAutocomplete";
import axios, { Axios } from "axios";
import { CONSTANTS } from "config/constant";
import TextareaField from "components/AddressAutocomplete/TextareaField";
import { useTranslation } from "react-i18next";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import PhoneInput from "react-phone-input-2";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Import eye icons
import { Option } from "antd/es/mentions";
import { MdOutlineArrowBack } from "react-icons/md";
import { PlusOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { API_UPLOAD_IMAGE } from "api/user-mangement";
import { API_UPLOAD_IMAGE_STORE } from "api/store-managemnt";
const CreateStore = () => {
  const [autocompleteSuggestions, setAutocompleteSuggestions] = useState([]);
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const Navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10, // adjust as needed
    totalPages: 1, // initial value, will be updated on data fetch
  });

  const [fileList, setFileList] = useState([
    // {
    //   uid: "",
    //   name: "",
    //   status: "",
    //   url: "",
    // },
  ]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [image, setImage] = useState();
  const searchAddress = async (address) => {
    // formik.setFieldValue("street_address_camp", address);
    console.log("address", address);
    try {
      const response = await axios.get(
        // `https://maps.googleapis.com/maps/api/place/autocomplete/json?input=${address}&key=${CONSTANTS?.googleApikey}`
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/places-autocomplete?query=${address}`
      );
      if (
        response.data.status === "OK" &&
        response.data.predictions.length > 0
      ) {
        const predictions = response.data.predictions;
        setAutocompleteSuggestions(predictions);

        console.log("Address predictions:", predictions);
      } else {
        setAutocompleteSuggestions([]);
        // Handle no results or error cases
        console.error("No address predictions found or error occurred");
      }
    } catch (error) {
      // Handle request error
      console.error("Error fetching data from Google Places API", error);
    }
  };

  const onSelectAddress = async (selectedAddress, setFieldValue) => {
    console.log("selectedAddress", selectedAddress);
    try {
      // Fetch place details using the Place Details request
      const response = await axios.get(
        `${CONSTANTS.BACKEND_URL_PUBLIC}/google/place-details?place_id=${selectedAddress.place_id}`
      );
      //  await axios.get(`${CONSTANTS.BACKEND_URL}api/public/google/place-details?place_id=${selectedAddress.place_id}`);

      if (response.data.status === "OK") {
        const placeDetails = response.data.result;
        console.log("Place Details:", placeDetails);
        const postalCode = placeDetails?.address_components?.find((component) =>
          component.types.includes("postal_code")
        )?.long_name;

        const city = placeDetails?.address_components?.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        const state = placeDetails?.address_components?.find((component) =>
          component.types.includes("administrative_area_level_1")
        )?.long_name;

        const country = placeDetails?.address_components?.find((component) =>
          component.types.includes("country")
        )?.long_name;
        const lat = placeDetails?.geometry?.location?.lat;
        const lng = placeDetails?.geometry?.location?.lng;
        console.log("postalCode", postalCode);
        // setFieldValue("location", placeDetails?.formatted_address);
        setFieldValue("location", selectedAddress?.description);
        setFieldValue("geo", { coordinates: [lat, lng] });
        setFieldValue("location_lat", lat);
        setFieldValue("location_lng", lng);
        console.log("lat long", lat, lng);
        setAutocompleteSuggestions([]);
      } else {
        console.error("Error fetching place details from Google Places API");
      }

      // Clear the autocomplete suggestions
      setAutocompleteSuggestions([]);
    } catch (error) {
      console.error(
        "Error fetching place details from Google Places API",
        error
      );
    }
  };

  // const fetchData = async () => {
  //   try {
  //     const params = {
  //       page: "",
  //       limit: "",
  //       name: "",
  //     };
  //     const newData = await API_LIST_MAIN_LAUNDRY(params);
  //     console.log("provider", newData);
  //     setData(newData?.laundry);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, []);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);

  const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      // Create a FormData object
      const formData = new FormData();
      formData.append("images", file);
      const response = await API_UPLOAD_IMAGE_STORE(formData);

      console.log("result", response, file);
      // Handle success
      const newFileList = [
        {
          uid: response.id, // Replace with the unique ID you receive from the server
          name: response?.file?.[0]?.name,
          status: "done",
          url: CONSTANTS?.IMG_DIRECTORY + response?.file?.[0]?.file_url, // Replace with the URL of the uploaded image
        },
      ];

      console.log(newFileList);
      setFileList(newFileList);
      setImage(response?.file?.[0]);
      onSuccess();
      toast.success(response?.message);

      console.log("result", response);
      console.log("newFileList", newFileList);
    } catch (error) {
      toast.error(error?.message);
      // Handle exceptions and errors
      console.log("error", error);
      onError(error);
    }
  };
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {/* <Avatar size={64} icon={<UserOutlined />} /> */}

      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("Upload")}
      </div>
    </button>
  );
  const fetchData = async (page) => {
    try {
      setLoading(true);
      const params = {
        page: page,
        limit: pagination.pageSize,
        name: "",
      };
      const newData = await API_LIST_MAIN_LAUNDRY(params);
      setData((prevData) => [...prevData, ...newData.laundry]);
      setPagination((prevPagination) => ({
        ...prevPagination,
        totalPages: newData.totalPages,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current);
  }, [pagination.current]);

  const handleScroll = (e) => {
    const { target } = e;
    if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
      if (pagination.current < pagination.totalPages) {
        setPagination((prevPagination) => ({
          ...prevPagination,
          current: prevPagination.current + 1,
        }));
      }
    }
  };

  // sasasasasssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssssss
  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const params = {
  //       page: pagination.current,
  //       limit: pagination.pageSize,
  //       name: "",
  //     };
  //     const newData = await API_LIST_MAIN_LAUNDRY(params);
  //     setData((prevData) => [...prevData, ...newData.laundry]);
  //     setPagination({
  //       ...pagination,
  //       totalPages: newData.totalPages,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [pagination.current]); // Call fetchData when pagination.current changes

  // const handleScroll = (e) => {
  //   const { target } = e;
  //   if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
  //     if (pagination.current < pagination.totalPages) {
  //       setPagination((prevPagination) => ({
  //         ...prevPagination,
  //         current: prevPagination.current + 1,
  //       }));
  //     }
  //   }
  // };
  // const handlePhoneChange = (value, setFieldValue, field) => {
  // if (value.replace(/\D/g, '').length <= 12) {
  //   return;
  // } else {
  //   console.log('Iamvaluesss','phoneValue')
  //   setFieldValue(field, value);
  // }
  // };

  const handlePhoneChange = (value, setFieldValue, field) => {
    console.log(value, "lfhldaksdjfl");
    const phoneWithoutCountryCode = value.replace(/\D/g, "");

    const saudiCountryCode = "966";
    if (phoneWithoutCountryCode.startsWith(saudiCountryCode)) {
      const digitsAfterCountryCode = phoneWithoutCountryCode?.slice(
        saudiCountryCode.length
      );
      console.log("digitsAfterCountryCode", digitsAfterCountryCode);

      if (digitsAfterCountryCode) {
        console.log("more");
        setFieldValue(field, value);
      }
    }
  };
  return (
    <>
      <div className=" mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-center">
        <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0">
          <Formik
            initialValues={{
              store_name: "",
              description: "",
              laundry: "66c70ccc43e12384d42979a8",
              geo: { coordinates: [] },
              location: "",
              location_lat: "",
              location_lng: "",
              password: "",
              email: "",
              phone_number: "",
              confirm_password: "",
              address: "",
              store_owner_first_name: "",
              store_owner_last_name: "",
              store_owner_email: "",
              store_owner_phone_no: "",
            }}
            validationSchema={Yup.object({
              store_name: Yup.string().required("Required"),
              description: Yup.string()
                .required("Required")
                .test(
                  "max-words",
                  "Description must be at most 150 words",
                  (value) => value.trim().split(/\s+/).length <= 150
                ),
              email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              password: Yup.string().required("Required"),
              confirm_password: Yup.string()
                .required("Required")
                .oneOf([Yup.ref("password"), null], "Passwords must match"),
              phone_number: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),

              // .matches(/^[0-9]+$/, "Phone number must contain only numbers")
              // .max(12, "Phone number must be at most 12 characters long"),

              // laundry: Yup.string().required("Required"),
              location: Yup.string().required("Required"),
              store_owner_first_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              store_owner_last_name: Yup.string()
                .required("Required")
                .matches(/^[^\d]+$/, "Name cannot contain numbers")
                .max(50, "Maximum character should be 50"),
              store_owner_email: Yup.string()
                .email("Invalid email format")
                .matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email format"
                )
                .test("valid-domain", "Invalid email format", function (value) {
                  if (!value) return true; // Skip if empty
                  const domain = value.split("@")[1]; // Extract domain part
                  return !!domain && /\./.test(domain); // Check for dot in domain part
                })
                .max(40, "Maximum character long before @")
                .required("Required"),
              store_owner_phone_no: Yup.string()
                .required("Required")
                .length(12, "please enter correct Phone number"),

              // .matches(/^[0-9]+$/, "Phone number must contain only numbers")
              // .max(12, "Phone number must be at most 12 characters long"),
            })}
            onSubmit={async (
              values,
              { setSubmitting, setFieldError, error }
            ) => {
              console.log("values", error, values);
              try {
                const {
                  store_owner_first_name,
                  store_owner_last_name,
                  store_owner_email,
                  store_owner_phone_no,
                  location,
                  address,
                  location_lat,
                  location_lng,
                  geo,
                  ...storeData
                } = values;

                const storeOwnerInfo = {
                  first_name: store_owner_first_name,
                  last_name: store_owner_last_name,
                  email: store_owner_email,
                  phone_no: store_owner_phone_no,
                };
                const latLng = `${location_lat},${location_lng}`;

                const payload = {
                  ...storeData,
                  location: {
                    coordinates: [location_lat, location_lng],
                    // address: location,
                  },
                  geo: geo,
                  address: location,

                  // location: {
                  //   lat_long: latLng,
                  //   address: location,
                  // },
                  ...(image ? { profile_image: [image] } : {}), // Add profile_image only if image is not null/undefined

                  // profile_image: [image],

                  store_owner_info: storeOwnerInfo,
                };

                const userData = await API_CREATE_STORE(payload);

                toast.success(userData?.message);
                Navigate("/admin/store-management/store-tables");
              } catch (error) {
                console.error("error===>", error);
                toast.error(error?.response?.data?.message);
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {({ isSubmitting, values, setFieldValue, setTouched }) => (
              <Form className="flex min-h-[36rem] w-full flex-col justify-between rounded-[20px] bg-white p-8 shadow-md">
                {console.log(values, "vlauessss")}
                <div
                  className="mb-4 flex w-[6rem] cursor-pointer items-center gap-2"
                  onClick={() => {
                    Navigate(-1);
                  }}
                >
                  <MdOutlineArrowBack
                    className="cursor-pointer"
                    style={{ fontSize: "17px" }}
                  />
                  <p>{t("Back")}</p>
                </div>

                <div className="mb-3 flex justify-center">
                  <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture-circle"
                    customRequest={customRequest}
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                  >
                    {fileList?.length == 1 ? null : uploadButton}
                  </Upload>
                  {previewImage && (
                    <Image
                      wrapperStyle={{
                        display: "none",
                      }}
                      preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) =>
                          !visible && setPreviewImage(""),
                      }}
                      src={previewImage}
                    />
                  )}
                </div>
                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  {t("Store Owner")}
                </h1>
                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("First Name")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="store_owner_first_name"
                        placeholder={t("First Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="store_owner_first_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Last Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Last Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="store_owner_last_name"
                        placeholder={t("Last Name")}
                        maxLength={50}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <ErrorMessage
                        name="store_owner_last_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Email")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Email")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="store_owner_email"
                        placeholder={t("Email")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="store_owner_email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="store_owner_phone_no"
                        placeholder={t("Phone No")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      /> */}
                      <PhoneInput
                        disableDropdown={true}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        country={"sa"}
                        inputClass="w-full "
                        length={"12"}
                        inputProps={{
                          className:
                            "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500  pl-[3rem]",

                          name: "store_owner_phone_no",
                          placeholder: "Phone No",
                          onKeyPress: (e) => {
                            const currentValue =
                              values.store_owner_phone_no || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.store_owner_phone_no}
                        onChange={(value) =>
                          handlePhoneChange(
                            value,
                            setFieldValue,
                            "store_owner_phone_no"
                          )
                        }
                        // onChange={(value) => {
                        //   if(values?.store_owner_phone_no.length === 9) {
                        //       return null
                        //   } else {
                        //     setFieldValue("store_owner_phone_no", value);
                        //   }
                        // }}
                        // style={{ Width: "100%", height: "2.7rem" }}
                      />
                      <ErrorMessage
                        name="store_owner_phone_no"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                </Row>

                <h1
                  style={{
                    fontWeight: "500",
                    fontSize: "20px",
                    textAlign: "start",
                    marginBottom: "2rem",
                  }}
                >
                  {t("Store")}
                </h1>

                <Row gutter={[16, 16]}>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {" "}
                        {t("Store Name")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store Name")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="store_name"
                        placeholder={t("Store Name")}
                        onKeyPress={(event) => {
                          const charCode = event.charCode;
                          if (
                            !(charCode >= 65 && charCode <= 90) && // A-Z
                            !(charCode >= 97 && charCode <= 122) && // a-z
                            charCode !== 32 // space
                          ) {
                            event.preventDefault();
                          }
                        }}
                        onInput={(event) => {
                          const value = event.target.value;
                          const wordCount = value?.trim()?.split(/\s+/).length;
                          if (wordCount > 5) {
                            const words = value
                              ?.trim()
                              ?.split(/\s+/)
                              ?.slice(0, 5)
                              ?.join(" ");
                            event.target.value = words;
                          }
                        }}
                      />
                      <ErrorMessage
                        name="store_name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  <Col span={8}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {t("Password")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        placeholder={t("Store Password")}

                        // autoComplete="off"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[5px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="relative mb-3">
                      <label className="font-semibold">
                        {t("Confirm Password")}
                        <span className="text-[red]">*</span>
                      </label>

                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type={showPassword ? "text" : "password"}
                        name="confirm_password"
                        placeholder={t("Password")}

                        // autoComplete="off"
                      />
                      <button
                        type="button"
                        onClick={() =>
                          setShowPassword((prevState) => !prevState)
                        }
                        className="absolute bottom-[5px] right-4 top-3"
                      >
                        {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
                      </button>
                      <ErrorMessage
                        name="confirm_password"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Phone No")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 pl-[3rem] text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto  rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Phone No")}
                      </label> */}
                      {/* <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="phone_number"
                        placeholder={t("Phone No")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which;
                          const keyValue = String.fromCharCode(keyCode);
                          const regex = /^[0-9]+$/;
                          if (!regex.test(keyValue)) {
                            event.preventDefault();
                          }
                        }}
                      /> */}
                      <PhoneInput
                        country={"sa"}
                        disableDropdown={true}
                        onlyCountries={["sa"]}
                        countryCodeEditable={false}
                        autoFormat={true}
                        enableLongNumbers={false}
                        // className="w-100 mt-2"
                        inputProps={{
                          className:
                            "bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500 pl-[3rem]",

                          name: "phone_number",
                          placeholder: "Phone No",
                          onKeyPress: (e) => {
                            const currentValue = values?.phone_number || "";
                            const digitsOnly = currentValue?.replace(/\D/g, ""); // Remove non-numeric characters

                            // Prevent input if there are already 12 digits
                            if (digitsOnly?.length >= 12 && /\d/?.test(e.key)) {
                              e.preventDefault();
                            }
                          },
                        }}
                        value={values?.phone_number}
                        onChange={(value) => {
                          setFieldValue("phone_number", value);
                        }}
                      />
                      <ErrorMessage
                        name="phone_number"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Store Email")}

                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store Email")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        type="text"
                        name="email"
                        placeholder={t("Store Email")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>

                  {/* <Col span={8}>
                    <div className="mb-3 flex flex-col">
                      <label className="font-semibold">
                        {t("Select Laundry")}

                        <span className="text-[red]">*</span>
                      </label> */}
                  {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Select Laundry")}
                      </label> */}
                  {/* <Select
                        placeholder="Select a laundry option"
                        onChange={(value) => console.log(value)} // Change the handler as needed
                        style={{ width: 180 }}
                        showSearch
                        optionFilterProp="children"
            
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onDropdownVisibleChange={(open) => {
                          if (
                            open &&
                            pagination.current < pagination.totalPages
                          ) {
                            fetchData();
                          }
                        }}
                        onPopupScroll={handleScroll}
                        loading={loading}
                      >
                        {data.map((value) => (
                          <Option key={value._id} value={value._id}>
                            {value.laundry_name}
                          </Option>
                        ))}
                
                      </Select> */}
                  {/* <Field name="laundry">
                        {({ field }) => (
                          <Select
                            className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                            {...field}
                            showSearch
                            placeholder="Select Laundry"
                            optionFilterProp="children"
                            onPopupScroll={handleScroll}
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            loading={loading}
                            // style={{ width: 180 }}
                          >
                            {data.map((item) => (
                              <Option key={item.id} value={item._id}>
                                {item.laundry_name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Field> */}

                  {/* ............................workingg............ */}
                  {/* <Field name="laundry">
                        {({ field }) => (
                          <Select
                            // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none "
                            className="bg-transparent peer block h-[3rem] w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                            {...field}
                            showSearch
                            placeholder="Select Laundry"
                            optionFilterProp="children"
                            onPopupScroll={handleScroll}
                            filterOption={(input, option) =>
                              option?.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            loading={loading}
                            onChange={(value) => {
                              setFieldValue("laundry", value);
                              setTouched({ laundry: true });
                            }}
                          >
                            {data.map((item) => (
                              <Option key={item._id} value={item._id}>
                                {item.laundry_name}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Field>
                    
                      <ErrorMessage
                        name="laundry"
                        component="div"
                        className="text-red-500"
                      /> */}
                  {/* </div>
                  </Col> */}

                  <Col xs={24} md={12} lg={8} className="">
                    {/* <label
                      for="floating_outlined"
                      className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                    >
                      {t("Location")}
                    </label> */}
                    <TextareaField
                      // className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                      className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                      label={t("Location")}
                      name="location"
                      placeholder={t("Location")}
                      value={values?.location}
                      handleChange={(e) => {
                        const addressInput = e.target.value;
                        setFieldValue("location", addressInput);
                        searchAddress(addressInput); // Call the address autocomplete function
                      }}
                      // required
                    />
                    <ErrorMessage
                      name="location"
                      component="div"
                      className="text-red-500"
                    />
                    {autocompleteSuggestions.length > 0 && (
                      <AddressAutocomplete
                        suggestions={autocompleteSuggestions}
                        // onSelectAddress={onSelectAddress}
                        onSelectAddress={(address) =>
                          onSelectAddress(address, setFieldValue)
                        }
                      />
                    )}
                  </Col>
                  <Col span={8}>
                    <div className="mb-3">
                      <label className="font-semibold">
                        {t("Store description")}
                        <span className="text-[red]">*</span>
                      </label>
                      {/* <label
                        for="floating_outlined"
                        className="absolute start-1 top-2 z-10 origin-[0] -translate-y-4 scale-75 transform bg-white px-2 text-sm text-gray-500 duration-300 peer-placeholder-shown:top-1/2 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:scale-100 peer-focus:top-2 peer-focus:-translate-y-4 peer-focus:scale-75 peer-focus:px-2 peer-focus:text-blue-600 dark:bg-gray-900 dark:text-gray-400 peer-focus:dark:text-blue-500 rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                      >
                        {t("Store description")}
                      </label> */}
                      <Field
                        // className="mt-2 flex h-11 min-h-20 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm  outline-none   "
                        className="bg-transparent peer block w-full appearance-none rounded-lg border-2 border-gray-300 px-2.5 pb-2.5 pt-4 text-sm text-gray-900 focus:border-blue-600 focus:outline-none focus:ring-0 dark:border-gray-600 dark:text-white dark:focus:border-blue-500"
                        as="textarea"
                        name="description"
                        placeholder={t("Store description")}

                        // autoComplete="off"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col>
                  {/* 
                  <Col span={8}>
                    <div className="mb-3">
                      <label>
                        Store location <span className="text-[red]">*</span>
                      </label>

                      <Field
                        className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none  "
                        type="text"
                        name="location"
                        placeholder="Location"
                        handleChange={(e) => {
                          const addressInput = e.target.value;
                          console.log("addressInput",addressInput)
                          searchAddress(addressInput); // Call the address autocomplete function
                        }} // autoComplete="off"
                      />
                      {autocompleteSuggestions.length > 0 && (
                        <AddressAutocomplete
                          suggestions={autocompleteSuggestions}
                          onSelectAddress={onSelectAddress}
                        />
                      )}
                      <ErrorMessage
                        name="location"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                  </Col> */}
                </Row>
                <div className="flex justify-end">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="linear mt-2 w-full max-w-[9rem] rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                  >
                    {isSubmitting ? t("Creating") + "..." : t("Create Store")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default CreateStore;
